import React from 'react';
import GenericSelect from '../../../../../components/common/GenericSelect';
import { coreTypes } from 'dealer-website-components';
import { filter, includes, map, some } from 'lodash';
import { groupFuels } from './fuelUtils';

const FuelFilter = ({ filterData, filterValues, filterAdd, filterDelete }) => {
  const { FilterTypes } = coreTypes;
  const items = groupFuels(filterData);
  const selectedValues = map(
    filter(items, (item) => some(item.key.split(','), (key) => includes(filterValues, key))),
    'key'
  );

  const handleChange = (data) => {
    const keys = data.value.split(',');
    if (some(keys, (key) => includes(filterValues, key))) {
      keys.forEach((key) => filterDelete(FilterTypes.fuel, key));
    } else {
      keys.forEach((key) => filterAdd(FilterTypes.fuel, key));
    }
  };

  return (
    <React.Fragment>
      <div className='builder-font-semibold builder-mb-2 builder-mt-5'>Fuel</div>
      <GenericSelect placeHolder='All' items={items} values={selectedValues} handleFilterChanged={handleChange} />
    </React.Fragment>
  );
};

export default FuelFilter;
